export const RECENT_SEARCHES_STORAGE = 'LS_recentSearches_V2';
export const RECENT_SEARCHES_LEGACY_STORAGE = 'LS_recentSearches';
export const RECENT_LOCATIONS_STORAGE = 'LS_recentLocations';
export const CATEGORIES_STORAGE = 'LS_categories_v2';
export const GEOLOCATION = 'LS_geolocation_v2';
export const RVD_STORAGE = 'LS_recentlyViewedDeals_v2';
export const SUBNAV_STORAGE = 'LS_subnav_v2';
